import React, { useState, useEffect, useContext } from "react";
import AppGlobalContext from "../../../../AppGlobalContext";
import StarIcon from "@material-ui/icons/Star";
import fire from "../../../../services/fire";
import "../../assets/css/event-card.css";

const EventInterestButton = ({
  eventId = "",
  isPreview = true,
  eventPageState = {
    isLoading: true,
    isNotFound: true,
    eventDetails: {},
    isLoginModalOpen: false,
    isLoginSuccess: false,
    buttonClicked: "",
    selectedSchedule: "",
  },
  setInterest = () => {},
  setEventPageState = () => {},
}) => {
  const [interestState, setInterestState] = useState(0);
  const { user } = useContext(AppGlobalContext);
  const { isLoginSuccess, buttonClicked } = eventPageState;

  useEffect(() => {
    if (user && isLoginSuccess && buttonClicked === "interest") {
      setInterest(eventId, () => {
        setInterestState(1);
      });
    }
  }, [user, isLoginSuccess]);

  useEffect(() => {
    if (!isPreview) {
      if (!user) {
        // Disabled, need to login
        setInterestState(-1);
      } else {
        if (eventId !== "") {
          fire
            .firestore()
            .collection("eventinterests")
            .where("eventId", "==", eventId)
            .where("createdBy", "==", user.userid)
            .get()
            .then((snapshot) => {
              if (!snapshot.empty) {
                const interestObj = snapshot.docs[0].data();
                if (interestObj.interest) {
                  setInterestState(1);
                }
              }
            });
        }
      }
    }
    // Run effect once on component mount, recheck if deps updated
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {(interestState === 0 || isPreview) && (
        <div
          className="event-card-interested__btn mr-3"
          onClick={() =>
            !isPreview
              ? setInterest(eventId, () => {
                  setInterestState(1);
                })
              : {}
          }
        >
          I'm Interested
        </div>
      )}
      {interestState === 1 && (
        <div className="d-flex text-center py-1 px-2 mr-2">
          <StarIcon className="mr-1 mt-1" style={{ color: "#0347AD" }} />
          Interested
        </div>
      )}
      {interestState === -1 && (
        <div
          className="event-card-interested__btn mr-3"
          onClick={() => {
            {
              setEventPageState({
                ...eventPageState,
                isLoginModalOpen: true,
                buttonClicked: "interest",
              });
            }
          }}
        >
          I'm Interested
        </div>
      )}
    </>
  );
};

export default EventInterestButton;
